import { getEnvironment } from "./environment"

export const APP_NAME = process.env.NEXT_PUBLIC_APP_NAME ?? "opensea-wallet"
export const BUILD_ID = process.env.BUILD_ID ?? "development"
export const ENVIRONMENT = getEnvironment()
